module.exports = __webpack_public_path__ + "img/silverlinings-locked.da7de39f.png";